import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { LEGACY_DATA_LOCALE } from './index';
import { applyHtmlLang, isLocale, persistLocale } from './locale';
import { LEGACY_LANGUAGE, type Locale } from './resources';

export interface UseLocale {
  /** The active UI locale; LEGACY_DATA_LOCALE while the legacy text is shown. */
  locale: Locale;
  /** True while the UI shows the pre-switch legacy text (UI_I18N_ENABLED off, nothing chosen). */
  legacy: boolean;
  /** Switch the UI locale, remember it in localStorage and update <html lang>. */
  setLocale: (next: Locale) => Promise<void>;
}

/** Read and change the UI locale. */
export function useLocale(): UseLocale {
  const { i18n } = useTranslation();
  const current = i18n.resolvedLanguage ?? i18n.language;
  const legacy = current === LEGACY_LANGUAGE;
  const locale: Locale = isLocale(current) ? current : LEGACY_DATA_LOCALE;

  const setLocale = useCallback(
    async (next: Locale) => {
      persistLocale(typeof window !== 'undefined' ? window.localStorage : undefined, next);
      await i18n.changeLanguage(next);
      if (typeof document !== 'undefined') applyHtmlLang(document, next);
    },
    [i18n],
  );

  return { locale, legacy, setLocale };
}
